import {
  cases,
  experts, institutions, conferenceUnits, eventsDetail, eventsOverview, eventCases, eventForums
} from '@/mock/data'
import api from '@/api/axiosConfig';
 
const createResponse = (data) => ({
  code: 200,
  data,
  timestamp: Date.now()
})

/**
 * 获取组织架构信息
 * @param {string|number} conventionId - 会议ID
 * @param {string|number} forumId - 论坛ID
  */
export const getOrgStructure = (conventionId, forumId) => {
  return api.get('/events/orgStructure', {
    params: {
      conventionId: conventionId,
      forumId: forumId
    }
  })
}
/**
* 获取议程信息
* @param {string|number} conventionId - 会议ID
* @param {string|number} forumId - 论坛ID
 */
export const getAgenda = (conventionId, forumId) => {
  return api.get('/events/agenda', {
    params: {
      conventionId: conventionId,
      forumId: forumId
    }
  })
}
/**
 * 获取案例征集
 * @param {string|number} conventionId - 会议ID
 * @param {string|number} forumId - 论坛ID
  */
export const getEventCollect = (conventionId, forumId) => {
  return api.get('/events/collectionInfo', {
    params: {
      conventionId: conventionId,
      forumId: forumId
    }
  })
}
export const meetingRaceList = (conventionId) => {
  return api.get('/events/meetingRaceList', {
    params: {
      conventionId: conventionId
    }
  })
}

export const meetingRaceDetail = (id) => {
  return api.get('/events/meetingRaceDetail', {
    params: {
      id: id
    }
  })
}
export const getEventCollectList = (conventionId, forumId) => {
  return api.get('/events/collectionList', {
    params: {
      conventionId: conventionId,
      forumId: forumId
    }
  })
}
export const getEventCollectDetail = (collectId) => {
  return api.get('/events/collectionDetail', {
    params: {
      collectId: collectId
    }
  })
}
export const getExperts = (page, pageSize) => {
  return api.get('/events/experts', {
    params: {
      page: page,
      pageSize: pageSize
    }
  })
}
// export const getExperts= (page,size) => createResponse(experts)
// export const getUnits= (page,province) =>createResponse(conferenceUnits)

/**
 * 大会、论坛架构
 * @param {*} conventionId 
 * @param {*} forumId 
 * @returns 
 */
export const getUnits = (conventionId, forumId) => {
  return api.get('/events/orgStructure', {
    params: {
      conventionId: conventionId,
      forumId: forumId
    }
  })
}
//  export const getEventsDetailById = (id) => createResponse(eventsDetail)
//  export const getEventsOverview = (id) =>  createResponse(eventsOverview)

/**
 * 大会、论坛概况
 * @param {*} conventionId 
 * @param {*} forumId 
 * @returns 
 */
export const getEventsOverview = (conventionId, forumId) => {
  return api.get('/events/intro', {
    params: {
      conventionId: conventionId,
      forumId: forumId
    }
  })
}

/**
 * 服务指南
 * @param {*} conventionId 
 * @returns 
 */
export const getEventsService = (conventionId) => {
  return api.get('/events/service', {
    params: {
      conventionId: conventionId 
    }
  })
}
/**
 * 平行论坛
 * @param {*} id  大会id
 * @returns 
 */
// export const getEventForums = (id) => createResponse(eventForums)
export const getEventForums = (conventionId) => {
  return api.get('/events/forumList', {
    params: {
      conventionId: conventionId
    }
  })
}
/**
 * 历届活动
 */
export const getEventsHistory = () => {
  return api.get('/events/history', {
    params: {

    }
  })
}
/**
 * 其他活动
 * @returns 
 */
export const getOtherEvents = () => {
  return api.get('/events/otherConventions', {
    params: {

    }
  })
}

/**
 * 组委会
 * @returns 
 */
export const getCommittees = () => {
  return api.get('/events/committees', {
    params: {
      page:1,
      pageSize:60
    }
  })
}
export const getCommiteeTypeContent = (type,page) => {
  return api.get('/events/committees', {
    params: {
      type:type,
      page:page,
      pageSize:24
    }
  })
}
export const getCommitteeHome = () => {
  return api.get('/events/committeeHome', {
    params: {
    
    }
  })
}
export const eventsRegister = (params) => {
  return api.post('/eventsRegist/submit', params, 
     { headers: { 'Content-Type': 'application/json;charset=UTF-8' } })
}
export  const checkTime=(conventionId)=> api.get(`/eventsRegist/checkTime?conventionId=${conventionId}`)
// 签到
export const orderCheckIn = (conventionId,phone) => {
  return api.post('/orderCheck/submit', {
    cid: conventionId,
    phone: phone
  }, {
    headers: { 'Content-Type': 'application/json;charset=UTF-8' }
  })
}

export default {
  getExperts,
  getUnits,
  getEventsOverview,
  getEventCollect,
  getEventForums,
  getEventsHistory,
  getOtherEvents,
  getCommittees,
  getCommitteeHome,
  getEventsService,
  getAgenda,
  getOrgStructure,
  eventsRegister,
  checkTime,
  getCommiteeTypeContent,
  getEventCollectList,
  getEventCollectDetail,
  meetingRaceList,
  meetingRaceDetail,
  orderCheckIn
}